import { render, staticRenderFns } from "./StatsBuilderExtra.vue?vue&type=template&id=04113410"
import script from "./StatsBuilderExtra.vue?vue&type=script&lang=js"
export * from "./StatsBuilderExtra.vue?vue&type=script&lang=js"
import style0 from "./StatsBuilderExtra.vue?vue&type=style&index=0&id=04113410&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports